import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../apiBase';
import { createPlatformApi } from '../utils/platformApi';
import { getOwnedSchoolIdForBilling } from '../utils/activeSchool';


const fmt = (n) => new Intl.NumberFormat('ru-RU').format(n);

export default function PlanChangeModal({ open, onClose, currentPlan, onSuccess }) {
    const { t } = useTranslation(['platformBilling', 'common', 'nav', 'messages', 'errors']);
    const [plans, setPlans] = useState([]);
    const [selected, setSelected] = useState(null);
    const [billingPeriod, setBillingPeriod] = useState('monthly');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (open) {
            axios.get(`${getApiBaseUrl()}/platform/plans`).then((r) => setPlans(r.data || []));
            setSelected(null);
            setMessage('');
        }
    }, [open]);

    if (!open) return null;

    const currentSort = plans.find((p) => p.id === currentPlan?.id)?.sortOrder
        ?? plans.findIndex((p) => p.id === currentPlan?.id);

    function getPlanSort(p) {
        const idx = plans.findIndex((x) => x.id === p.id);
        return idx >= 0 ? idx : p.id;
    }

    const isUpgrade = selected && (
        getPlanSort(selected) > (typeof currentSort === 'number' ? currentSort : 0)
    );

    async function confirm() {
        if (!selected) return;
        setLoading(true);
        setMessage('');
        try {
            const api = createPlatformApi();
            const schoolId = getOwnedSchoolIdForBilling();
            const res = await api.post('/platform/billing/change-plan', {
                planId: selected.id,
                billingPeriod
            }, { params: schoolId ? { schoolId } : {} });

            if (res.data.confirmationUrl) {
                window.location.href = res.data.confirmationUrl;
                return;
            }
            setMessage(res.data.message || t('platformBilling:planChangeModal.planUpdated'));
            onSuccess?.();
        } catch (err) {
            setMessage(err.response?.data?.message || t('platformBilling:planChangeModal.changeError'));
        }
        setLoading(false);
    }

    return (
        <div style={overlay} onClick={onClose}>
            <div style={modal} onClick={(e) => e.stopPropagation()}>
                <h3 style={{ marginTop: 0 }}>{t('platformBilling:planChangeModal.title')}</h3>
                <div style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
                    <button type="button" onClick={() => setBillingPeriod('monthly')}
                        style={billingPeriod === 'monthly' ? tabActive : tab}>{t('platformBilling:planChangeModal.monthly')}</button>
                    <button type="button" onClick={() => setBillingPeriod('annual')}
                        style={billingPeriod === 'annual' ? tabActive : tab}>{t('platformBilling:planChangeModal.annual')}</button>
                </div>
                {plans.map((p) => (
                    <label key={p.id} style={{
                        display: 'block', padding: '12px', marginBottom: '8px',
                        border: selected?.id === p.id ? '2px solid #4f46e5' : '1px solid #e5e7eb',
                        borderRadius: '10px', cursor: 'pointer'
                    }}>
                        <input type="radio" name="plan" checked={selected?.id === p.id}
                            onChange={() => setSelected(p)} style={{ marginRight: '8px' }} />
                        <strong>{p.displayName}</strong> — {fmt(billingPeriod === 'annual' ? p.annualPrice : p.monthlyPrice)} ₽
                    </label>
                ))}
                {selected && (
                    <p style={{ fontSize: '14px', color: isUpgrade ? '#059669' : '#b45309', background: '#fffbeb', padding: '12px', borderRadius: '8px' }}>
                        {isUpgrade
                            ? t('platformBilling:planChangeModal.upgradeHint')
                            : t('platformBilling:planChangeModal.downgradeHint')}
                        {!isUpgrade && selected.maxSchools < 999999 && (
                            <><br />{t('platformBilling:planChangeModal.schoolLimitHint', { max: selected.maxSchools })}</>
                        )}
                    </p>
                )}
                {message && <p style={{ color: '#059669' }}>{message}</p>}
                <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
                    <button type="button" onClick={confirm} disabled={!selected || loading}
                        style={{ flex: 1, padding: '12px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '10px', fontWeight: 600, cursor: 'pointer' }}>
                        {loading ? '...' : t('common:confirm')}
                    </button>
                    <button type="button" onClick={onClose} style={{ padding: '12px 20px', border: '1px solid #ddd', borderRadius: '10px', background: '#fff' }}>{t('common:cancel')}</button>
                </div>
            </div>
        </div>
    );
}

const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
const modal = { background: '#fff', borderRadius: '16px', padding: '24px', maxWidth: '480px', width: '95%' };
const tab = { padding: '8px 16px', border: '1px solid #ddd', borderRadius: '8px', background: '#fff', cursor: 'pointer' };
const tabActive = { ...tab, background: '#4f46e5', color: '#fff', borderColor: '#4f46e5' };
